<template>
  <svg width="308" height="184" viewBox="0 0 308 184" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="144" cy="-186" r="370" fill="#EEEEEE"/>
  </svg>
</template>